import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewChild, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { CabService } from './cab.service';
import { ToastMessage } from '../../toast-message/toast-message.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { MatDialog } from '@angular/material';
import { PopUpMessageComponent } from '../../pop-up-message/pop-up-message.component';
import { LogService } from '../../log-service.service';
import { ConstantsService } from '../../constants.service';
import { Subject } from 'rxjs';
import { Hotkey, HotkeysService } from 'angular2-hotkeys';
import { ImageViewComponent } from '../../image-view/image-view.component';
import { ImageZoomService } from '../../services/image-zoom.service';

// @ts-ignore
const _ = require('lodash');
const moment = require('moment');
@Component({
  // tslint:disable-next-line:component-selector
  selector: 'cab-doc',
  template: require('./cab.component.html'),
  providers: [ToastMessage, CabService, LogService, ConstantsService]
})
export class CabComponent implements OnChanges, OnDestroy {


  constructor(
    private _cabService: CabService,
    private _hotkeysService: HotkeysService,
    private _toastMessage: ToastMessage,
    private spinnerService: Ng4LoadingSpinnerService,
    private _logService: LogService,
    private dialog: MatDialog,
    private constantService: ConstantsService,
    private _changeDetector: ChangeDetectorRef,
    private imageZoomService: ImageZoomService) { }

  @Input() name: string;
  @Input() data: any;
  @Input() isCabDoc = true;
  @Input() userIdentity: any = {};
  @Input() isRejected: any;
  @Input() isApproved: any;
  @Input() isImageOptional: boolean = true;
  @Output() addCardToRejectList: EventEmitter<any> = new EventEmitter();
  @Output() rejected = new EventEmitter();
  @Output() approved = new EventEmitter();
  @ViewChild('permitImageView') permitImageView: ImageViewComponent;
  public screenBreakpoint = false;

  public updateImageEnabled = false;
  public allowEditing = true;
  public minDate = new Date();
  public riderId: any;
  public changedDetailsOfDoc = [];
  public showApproveButton = false;
  public showSubmitButton = false;
  public showButtonIcon = false;
  public isActive = false;
  public fleetNumber = "";
  public isFleetOnboarding = false;
  public hideImageUploadForFleetOnboarding = false;
  public docType: any;
  public cabData: any;
  public APPROVAL_MESSAGE = this.constantService.approvalMessage;
  public approvalMessage = '';
  public imgFront: any;
  public expiresOn: Date;
  public oldExpireOn: any;
  public asyncRefreshTrigger: Subject<void> = new Subject<void>();
  public isImageUpdateInProgress = false; // Track when image update is in progress

  private rotateFrontImageDegrees = 0;
  public docFrontImageData: any;

  onResize(event) {
    this.screenBreakpoint = (event.target.innerWidth <= 1040) ? true : false;
  }

  ngOnChanges(changes: SimpleChanges) {
    this.riderId = changes.userIdentity ? changes.userIdentity.currentValue.userId : this.riderId;
    if (changes.data) {
      this.isActive = changes.data.currentValue.active
      this.fleetNumber = changes.data.currentValue.fleetNumber
      if (this.fleetNumber) {
        this.hideImageUploadForFleetOnboarding = true
        this.isFleetOnboarding = true
      }
    }
    this.docType = changes.name ? changes.name.currentValue : "cab";
    this.getCabData(this.riderId, this.fleetNumber);
  }

  ngOnInit() {
    this.getCabData(this.riderId, this.fleetNumber);
    // Show BlowupLens using vanilla JavaScript
    const blowupLens = document.getElementById('BlowupLens');
    if (blowupLens) {
      blowupLens.style.display = 'block';
    }
    this.screenBreakpoint = (window.innerWidth <= 1040) ? true : false;
  }

  getCabData(riderId, number) {
    let doc;
    this._cabService.getCabData(riderId, number).subscribe(
      response => {
        doc = response;
        const document = doc[this.name];
        this.cabData = document;
        const expiresOn = document && document.info && document.info.expiresOn;
        if (expiresOn > 0) {
          this.expiresOn = new Date(expiresOn);
        } else {
          this.expiresOn = null; // or leave it undefined based on your use case
        }
        if (document && document.images && document.images.front && document.images.front.path) {
          this.imgFront = document.images.front.path;
          if (this.fleetNumber) {
            this.hideImageUploadForFleetOnboarding = false
          }
        } else {
          this.imgFront = null;
        }

        if (document && document.approvalInfo && document.approvalInfo.approvedAt) {
          this.showApproveButton = false;
          this.showSubmitButton = false;
          this.isApproved = true;
          console.log('getCabData - isApproved set to true');
          if (document.approvalInfo.isAutoApproved) {
            this.approvalMessage = this.APPROVAL_MESSAGE.autoApproved
          } else {
            this.approvalMessage = this.APPROVAL_MESSAGE.agentApproved
          }
        }
        // Check if document is rejected - show both approve and reject buttons
        else if (document && document.rejectionInfo && document.rejectionInfo.front && document.rejectionInfo.front.timestamp) {
          this.showApproveButton = true;
          this.showSubmitButton = false;
          this.isRejected = true;
          this.imgFront = null; // Clear the image when document is rejected
        }
        else if (this.imgFront) {
          this.showApproveButton = true;
        } else {
          this.imgFront = null;
          // Show approve button even without image for cab documents
          this.showApproveButton = true;
        }

        // If image update is in progress, preserve the approve button visibility
        if (this.isImageUpdateInProgress) {
          this.showApproveButton = true;
          this.isApproved = false; // Hide approval text during update
        }

        // Reset the image update progress flag after data is loaded
        this.isImageUpdateInProgress = false;

        // After resetting the flag, ensure proper state for updated documents
        if (!this.isApproved && this.imgFront) {
          // If document has image but is not approved, show approve button
          this.showApproveButton = true;
        }
      },
      error => {
        const errorMessage = error && error.error && error.error.message || 'Could not fetch cab data';
        this._toastMessage.openSnackBarError(errorMessage);
      });
  }

  addToBulkRejection(event) {
    this.addCardToRejectList.emit(event);
    this.isApproved = false;
  }

  private openChangeDetailsDialog(actionFunction: () => void, docType: string): void {
    const dialogRef = this.dialog.open(PopUpMessageComponent, {
      width: '550px',
      data: {
        options: [],
        title: `Please confirm for the changed details in ${docType}`,
        message: '',
        data: {
          type: 'orderedList',
          info: this.changedDetailsOfDoc,
          note: 'Are you sure you want to update above details',
        },
        reason: 'changeDocDetails',
        buttonText: 'Yes',
        cancelText: 'No',
        styles: {
          title: 'font-size-20 margin-bottom-30',
          actionClass: 'doc-details-change-confirm',
          note: 'margin-bottom-12 margin-top-30 color-grey'
        }
      }
    });

    dialogRef.afterClosed().subscribe(confirm => {
      if (confirm) {
        actionFunction();
      } else {
        this.expiresOn = new Date(this.cabData.info.expiresOn);
        this.showButtonIcon = false;
      }
      this.changedDetailsOfDoc.splice(0, this.changedDetailsOfDoc.length);
    });
  }

  viewDetailsForExpiresOnUpdate() {
    const expiretime = moment(this.expiresOn).format('YYYY-MM-DD');
    if (this.isNotExisting()) {
      const evtTime = moment(this.cabData.info.expiresOn).format('YYYY-MM-DD');
      if (expiretime !== evtTime) {
        this.changedDetailsOfDoc.push(`Existing Expiry date: ${evtTime}`)
        this.changedDetailsOfDoc.push(`New Expiry date: ${expiretime}`)
      }
    }
    if (this.changedDetailsOfDoc.length > 0 && this.isActive) {
      this.openChangeDetailsDialog(() => this.updateExpiresOn(), this.docType);
    } else {
      this.updateExpiresOn();
    }
  }

  viewDetailsForChangedDocs() {
    const expiretime = moment(this.expiresOn).format('YYYY-MM-DD');
    if (this.isNotExisting()) {
      const evtTime = moment(this.cabData.info.expiresOn).format('YYYY-MM-DD');
      if (expiretime !== evtTime) {
        this.changedDetailsOfDoc.push(`Existing Expiry date: ${evtTime}`)
        this.changedDetailsOfDoc.push(`New Expiry date: ${expiretime}`)
      }
    }
    if (this.changedDetailsOfDoc.length > 0 && this.isActive) {
      this.openChangeDetailsDialog(() => this.approve(), this.docType);
    } else {
      this.approve();
    }
  }

  approve() {
    if (!this.isImageOptional && !this.imgFront) {
      this._toastMessage.openSnackBarError(`Please upload ${this.name} image before approving`);
      return;
    }
    if (this.expiresOn === null || isNaN(this.expiresOn.getTime())) {
      this._toastMessage.openSnackBarError('Please add an expiry');
      return;
    }

    if ((!this.cabData || !this.cabData.info || !this.cabData.info.expiresOn) || this.isNotExisting()) {
      const ts = this.expiresOn.getTime();
      this._cabService.updateInfo(this.name, this.riderId, this.fleetNumber, ts).subscribe(
        response => {
          this.showButtonIcon = false;
          this.performApproval();
        },
        err => {
          console.log('Error : ', err);
          this._toastMessage.openSnackBarError('Error while updating expiry');
        }
      );
    } else {
      this.performApproval();
    }
  }

  private performApproval() {
    this._cabService.approve(this.name, this.riderId, this.fleetNumber, this.riderId).subscribe(
      response => {
        this._toastMessage.openSnackBarSuccess(`Successfully approved ${this.name}`);
        this.isApproved = true;
        this.approvalMessage = this.APPROVAL_MESSAGE.agentApproved;
        this.showApproveButton = false;
        this.approved.emit();
      },
      err => {
        console.log('Error : ', err);
        this._toastMessage.openSnackBarError('Successfully rejected permit');
      }
    );
  }

  private isNotExisting() {
    return this.cabData && this.cabData.info &&
      this.cabData.info.expiresOn &&
      this.cabData.info.expiresOn !== undefined &&
      this.cabData.info.expiresOn !== null;
  }
  updateImageUrl(evt: any) {
    if (evt.mode === 'delete') {
      this.showApproveButton = true;
      this.updateImageEnabled = false;
      this.isImageUpdateInProgress = false; // Reset flag when image is deleted
      if (document.getElementById('BlowupLens')) {
        if (window) {
          const blowupLens = document.getElementById('BlowupLens');
          if (blowupLens) {
            blowupLens.style.display = 'none';
          }
        }
      }
      this.getCabData(this.riderId, this.fleetNumber);
    }
    if (evt.mode === 'update') {
      this.isImageUpdateInProgress = true; // Set flag when image update is in progress
      // Allow getCabData call to refresh data, but handle state properly
      this.getCabData(this.riderId, this.fleetNumber);
      this.rejected.emit(false);
      this.approved.emit(false);
    }
  }

  // Method to reset image-view component UI after rejection
  resetImageViewUI() {
    // This will be called from the parent component after rejection is confirmed
    if (this.permitImageView) {
      this.permitImageView.resetUIAfterRejection();
    }
  }

  datePickerOpened(evt: any) {
    this._hotkeysService.add(new Hotkey('left', (event: KeyboardEvent): boolean => {
      event.preventDefault();
      return false; // Prevent bubbling
    }));
    this._hotkeysService.add(new Hotkey('right', (event: KeyboardEvent): boolean => {
      event.preventDefault();
      return false; // Prevent bubbling
    }));
  }

  datePickerClosed(evt: any) {
    this._hotkeysService.add(new Hotkey('left', (event: KeyboardEvent): boolean => {
      document.getElementById('backButton').click();
      return false; // Prevent bubbling
    }));
    this._hotkeysService.add(new Hotkey('right', (event: KeyboardEvent): boolean => {
      document.getElementById('nextButton').click();
      return false; // Prevent bubbling
    }));
    this.showButtonIcon = true;
  }


  dateChanged(evt: any) {
    console.log('new date: ', evt.target.value.getTime());
  }

  updateExpiresOn() {
    const ts = this.expiresOn.getTime();
    this._cabService.updateInfo(this.name, this.riderId, this.fleetNumber, ts).subscribe(
      response => {
        this._toastMessage.openSnackBarSuccess('Successfully Updated Expiry');
        this.showButtonIcon = false;
      },
      err => {
        console.log('Error : ', err);
        this._toastMessage.openSnackBarError('Error while updating expiry');
      }
    );
  }

  rotateImage(link, degrees, key) {
    if (key === 'front') {
      this.rotateFrontImageDegrees += degrees;
      degrees = this.rotateFrontImageDegrees;
    }
    let response;
    this.spinnerService.show();
    this._cabService.rotateImage(link, degrees).subscribe(resp => {
      response = resp;
      this.spinnerService.hide();
      if (key === 'front') {
        setTimeout(() => {
          this.docFrontImageData = response.data;
          this.updateImageEnabled = true;
          const displayImage = document.getElementById('displayImage') as HTMLImageElement;
          if (displayImage) {
            displayImage.src = response.data;
            this.imageZoomService.initImageZoom('displayImage', {
              width: 400,
              height: 400,
              border: '1px solid black',
              round: false
            });
          }
        }, 300);
      }
    },
      error => {
        const errorMessage = error && error.error && error.error.message || `Could not rotate ${this.name}`;
        this._toastMessage.openSnackBarError(errorMessage);
        this.spinnerService.hide();
      });
  }

  updateImage(view) {
    let response;
    const riderId = this.riderId;
    if (view === 'front') {
      this._cabService.updateImage(this.docFrontImageData, this.riderId, this.name).subscribe(resp => {
        response = resp;
        this._toastMessage.openSnackBarSuccess('updated image has been saved');
        this._toastMessage.openSnackBarSuccess('Image Saved. Please reload.');
        this.updateImageEnabled = false;
        this.rotateFrontImageDegrees = 0;
        this.isImageUpdateInProgress = false; // Reset flag after image update is complete
        this.showApproveButton = true; // Ensure approve button is visible after update
        this.isApproved = false; // Hide approval text as document needs approval again
        this.refreshDisplayImage();
      },
        error => {
          const errorMessage = error && error.error && error.error.message || `Could not update ${this.name} image`;
          this._toastMessage.openSnackBarError(errorMessage);
        });
    }
  }

  refreshDisplayImage() {
    if (window) {
      // Replace jQuery document ready with vanilla JS
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
          this.initImageZoom();
        });
      } else {
        this.initImageZoom();
      }

      // Replace jQuery show() with vanilla JS
      const blowupLens = document.getElementById('BlowupLens');
      if (blowupLens) {
        blowupLens.style.display = 'block';
      }
      
      // Replace jQuery window width with vanilla JS
      this.screenBreakpoint = (window.innerWidth <= 1040) ? true : false;
    }
  }

  // New vanilla JS image zoom implementation
  private initImageZoom() {
    const displayImage = document.getElementById('displayImage') as HTMLImageElement;
    if (!displayImage) return;

    // Create zoom lens element if it doesn't exist
    let zoomLens = document.getElementById('BlowupLens');
    if (!zoomLens) {
      zoomLens = document.createElement('div');
      zoomLens.id = 'BlowupLens';
      zoomLens.style.cssText = `
        position: absolute;
        width: 400px;
        height: 400px;
        border: 1px solid black;
        background-repeat: no-repeat;
        display: none;
        pointer-events: none;
        z-index: 999999;
      `;
      document.body.appendChild(zoomLens);
    }

    // Add hover events for zoom functionality
    displayImage.addEventListener('mouseenter', (e) => this.showZoomLens(e));
    displayImage.addEventListener('mousemove', (e) => this.moveZoomLens(e));
    displayImage.addEventListener('mouseleave', () => this.hideZoomLens());
  }

  private showZoomLens(event: MouseEvent) {
    const zoomLens = document.getElementById('BlowupLens');
    const image = event.target as HTMLImageElement;
    
    if (zoomLens && image) {
      zoomLens.style.display = 'block';
      zoomLens.style.backgroundImage = `url(${image.src})`;
      zoomLens.style.backgroundSize = `${image.naturalWidth}px ${image.naturalHeight}px`;
      this.moveZoomLens(event);
    }
  }

  private moveZoomLens(event: MouseEvent) {
    const zoomLens = document.getElementById('BlowupLens');
    const image = event.target as HTMLImageElement;
    
    if (zoomLens && image) {
      const rect = image.getBoundingClientRect();
      const x = event.clientX - rect.left;
      const y = event.clientY - rect.top;
      
      // Calculate background position for zoom effect
      const xPercent = (x / rect.width) * 100;
      const yPercent = (y / rect.height) * 100;
      
      zoomLens.style.left = `${event.clientX + 20}px`;
      zoomLens.style.top = `${event.clientY + 20}px`;
      zoomLens.style.backgroundPosition = `${xPercent}% ${yPercent}%`;
    }
  }

  private hideZoomLens() {
    const zoomLens = document.getElementById('BlowupLens');
    if (zoomLens) {
      zoomLens.style.display = 'none';
    }
  }

  ngOnDestroy() {
    // Clean up zoom lens when component is destroyed
    this.imageZoomService.cleanup();
  }
}
